/**
 * Format an epoch date string into a human readable format
 */
export const formatDeliveryDate = (prefix, epoch, locale) => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    // The estimatedArrivalDate epoch is in seconds and needs to be converted to milliseconds
    const estimatedArrivalDate = new Date(parseInt(epoch) * 1000);
    const arrivalDate = estimatedArrivalDate.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
    if (estimatedArrivalDate.toDateString() === today.toDateString()) {
        return { localeKey: `${prefix}Today`, date: arrivalDate };
    }
    else if (estimatedArrivalDate.toDateString() === tomorrow.toDateString()) {
        return { localeKey: `${prefix}Tomorrow`, date: arrivalDate };
    }
    return {
        localeKey: prefix,
        date: estimatedArrivalDate.toLocaleDateString(locale, { weekday: 'long', month: 'short', day: 'numeric' }),
    };
};
/**
 * Format an epoch date string as the weekday, month and day (e.g. "Saturday, Sep 12"), with no
 * today/tomorrow wording, for surfaces that show the date on its own
 */
export const formatWeekdayDate = (epoch, locale) => new Date(parseInt(epoch) * 1000).toLocaleDateString(locale, { weekday: 'long', month: 'short', day: 'numeric' });
